var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5206 28.3882C39.9358 28.8019 40.2652 29.2934 40.4899 29.8347C40.7147 30.376 40.8304 30.9563 40.8304 31.5424C40.8304 32.1285 40.7147 32.7088 40.4899 33.2501C40.2652 33.7913 39.9358 34.2829 39.5206 34.6966L34.6965 39.5207C34.2828 39.9359 33.7912 40.2653 33.2499 40.49C32.7087 40.7148 32.1283 40.8305 31.5423 40.8305C30.9562 40.8305 30.3759 40.7148 29.8346 40.49C29.2933 40.2653 28.8017 39.9359 28.388 39.5207L5.00958 16.1423C4.17567 15.3043 3.70752 14.1703 3.70752 12.9881C3.70752 11.8059 4.17567 10.6718 5.00958 9.83383L9.8337 5.0097C10.6717 4.17579 11.8057 3.70764 12.9879 3.70764C14.1701 3.70764 15.3042 4.17579 16.1422 5.0097L39.5206 28.3882Z",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9038 23.1929L30.6147 19.4821",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3374 17.6265L25.0483 13.9156",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.771 12.0602L19.4819 8.34937",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4697 28.7593L36.1806 25.0485",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.2e921e5f6b961eaa485f3801b9d172ba.svg";
export { ForwardRef as ReactComponent };